import { Link, useLocation, useParams } from "react-router-dom";
import { InlineContent } from "../../../../components/Shared";
import { feedAndCommentHiddenMemoColumns, HiddenStatusSelect, useCreateFeedAndCommentHiddenMemoAdmin, useGetAllFeedOrCommentHiddenMemoAdminByHiddenIdAndTargetType, useGetFeedAndCommentClaimAdminByTargetClaimIdAndTargetType, useGetFeedAndCommentTotalClaimCntAdminByTargetIdAndTargetType } from "./model";
import { Button, Form, Input, Spin, Table } from "antd";
import dayjs from "dayjs";

const FeedAndCommentClaimManageDetail = () => {
    const id = Number(useParams().id)
    const targetType = new URLSearchParams(useLocation().search).get('targetType')
    const responseQuery = 'claimId claimNickName creatorNickName claimDateTime targetType category totalClaimCnt hiddenId status targetId content imageUrlList';
    const { data, isError, isPending } = useGetFeedAndCommentClaimAdminByTargetClaimIdAndTargetType<IFeedAndCommentClaimAdminResponse>(id, targetType ?? 'feed', responseQuery);
    const { data: totalClaimCnt } = useGetFeedAndCommentTotalClaimCntAdminByTargetIdAndTargetType(data?.targetId, data?.targetType ?? 'feed')
    const { data: memoList, refetch, isPending: isMemoListPending } = useGetAllFeedOrCommentHiddenMemoAdminByHiddenIdAndTargetType(data?.hiddenId, data?.targetType ?? 'feed')
    const createFeedAndCommentHiddenMemoAdmin = useCreateFeedAndCommentHiddenMemoAdmin(data?.targetType);

    const handleCreateMemo = (values: { memo: string }) => {
        const createFeedAndCommentHiddenMemoAdminRequest: ICreateFeedAndCommentHiddenMemoAdminRequest = {
            feedHiddenId: data?.targetType === 'feed' ? data?.hiddenId : undefined,
            feedCommentHiddenId: data?.targetType === 'feedComment' ? data?.hiddenId : undefined,
            content: values.memo
        }
        createFeedAndCommentHiddenMemoAdmin.mutate(createFeedAndCommentHiddenMemoAdminRequest, {
            onSuccess: () => {
                refetch()
            }
        })
    }
    if (isError || isPending) return <Spin size='large' />
    return <>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <InlineContent title='신고자' content={data.claimNickName} />
            <InlineContent title='작성자' content={data.creatorNickName} />
            <InlineContent title='신고일시' content={dayjs(data.claimDateTime).format('YYYY.MM.DD HH:mm')} />
            <InlineContent title='유형' content={data.targetType === 'feed' ? '게시글' : '댓글'} />
            <InlineContent title='신고사유' content={data.category} />
            <InlineContent title='누적 신고 수' content={totalClaimCnt} />
            <InlineContent title='처리 상태' content={<HiddenStatusSelect targetId={data.targetId} claimId={data.claimId} targetType={data.targetType} status={String(data.status)} />} />
            <InlineContent title='원본 게시글 ID' content={<Link to={data.targetType === 'feed' ? `/community/feed-manage/${data.targetId}` : `/community/feed-comment-manage/${data.targetId}`}>{data.targetId}</Link>} />
            <InlineContent title='내용' content={data.content} />
            <InlineContent title='사진' content={data.imageUrlList?.map((q, idx) => <img key={idx} src={q} width={60} height={60} alt="img" style={{ width: 'auto', height: '25vh', borderRadius: 4, marginRight: '12px' }} />)} />
        </div>

        <div style={{ marginTop: '24px', fontWeight: 700 }}>
            메모
        </div>
        <Form
            onFinish={handleCreateMemo}
        >
            <Form.Item name={'memo'} >
                <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
                    <Input.TextArea style={{ width: '30%' }} />
                    <Button htmlType='submit'>메모 추가</Button>
                </div>
            </Form.Item>
        </Form>
        <Table dataSource={memoList?.sort((a, b) => dayjs(b.createdDate).diff(dayjs(a.createdDate)))} rowKey={'id'} columns={feedAndCommentHiddenMemoColumns} style={{ marginTop: '24px' }} loading={data.hiddenId === null ? false : isMemoListPending} />
    </>
};

export default FeedAndCommentClaimManageDetail;